/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionResponseDto } from './PermissionResponseDto';
import {
    PermissionResponseDtoFromJSON,
    PermissionResponseDtoFromJSONTyped,
    PermissionResponseDtoToJSON,
    PermissionResponseDtoToJSONTyped,
} from './PermissionResponseDto';

/**
 * 
 * @export
 * @interface ListPermissionsResponseDto
 */
export interface ListPermissionsResponseDto {
    /**
     * 
     * @type {Array<PermissionResponseDto>}
     * @memberof ListPermissionsResponseDto
     */
    data: Array<PermissionResponseDto>;
}

/**
 * Check if a given object implements the ListPermissionsResponseDto interface.
 */
export function instanceOfListPermissionsResponseDto(value: object): value is ListPermissionsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListPermissionsResponseDtoFromJSON(json: any): ListPermissionsResponseDto {
    return ListPermissionsResponseDtoFromJSONTyped(json, false);
}

export function ListPermissionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPermissionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PermissionResponseDtoFromJSON)),
    };
}

export function ListPermissionsResponseDtoToJSON(json: any): ListPermissionsResponseDto {
    return ListPermissionsResponseDtoToJSONTyped(json, false);
}

export function ListPermissionsResponseDtoToJSONTyped(value?: ListPermissionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PermissionResponseDtoToJSON)),
    };
}

